import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, isDevMode } from '@angular/core';

@Component({
  selector: 'ui-skeleton-loader-legacy',
  templateUrl: './skeleton-loader-legacy.html',
  styleUrl: './skeleton-loader-legacy.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class SkeletonLoaderLegacyComponent implements OnInit {
  @Input() appearance: 'circle' | '' = '';

  @Input() animation: 'progress' | 'progress-dark' | 'pulse' | 'false' = 'progress';

  @Input() theme: { [k: string]: string } = {};

  ngOnInit() {
    const allowedAnimations = ['progress', 'progress-dark', 'pulse', 'false'];
    if (allowedAnimations.indexOf(this.animation) === -1) {
      if (isDevMode()) {
        console.error(
          `\`SkeletonLoaderComponent\` need to receive 'animation' as: ${allowedAnimations.join(
            ', '
          )}. Forcing default to "progress".`
        );
      }
      this.animation = 'progress';
    }
  }
}
